import React from "react"
import Button from "@mui/material/Button"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import Pagination from "@mui/material/Pagination"
import moment from "moment"

import { StyledMemberTable } from "./Member.style"

const MemberTable = ({
  members,
  access,
  openMemberDetail,
  searchResultInfo,
  searchOptions,
  setSearchOptions,
}) => {
  const hasRows = members && members.length > 0
  const hasSearch = !!searchResultInfo

  return (
    <StyledMemberTable>
      {searchResultInfo && searchResultInfo.total > 0 && (
        <div className="search-result-info">
          {searchResultInfo.total} records found.
        </div>
      )}

      {!access?.listMemberAccess && (
        <div className="permission-empty">
          You do not have permission to view members.
        </div>
      )}

      {access?.listMemberAccess && (
        <div className="table-shell">
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="member table">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                  <TableCell>Join At</TableCell>
                  <TableCell>Plan</TableCell>
                  <TableCell>Coach</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!hasRows && (
                  <TableRow key={"pg"}>
                    <TableCell colSpan={8} className="table-empty">
                      {hasSearch
                        ? "No members matched your filters."
                        : "Use filters above and click Search to load members."}
                    </TableCell>
                  </TableRow>
                )}

                {hasRows &&
                  members.map((row) => (
                    <TableRow
                      key={`member-item-${row.userId}`}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.userId}
                      </TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.firstName}</TableCell>
                      <TableCell>{row.lastName}</TableCell>
                      <TableCell>{moment(row.registerAt).format("lll")}</TableCell>
                      <TableCell>{row.subscriptionPlan}</TableCell>
                      <TableCell>
                        {row.connectedCoachName ? (
                          <>
                            {row.connectedCoachName}
                            {row.connectedCoachCount > 1 && (
                              <span style={{ color: "#6b7280", fontSize: 12 }}>
                                {" "}
                                (+{row.connectedCoachCount - 1} more)
                              </span>
                            )}
                          </>
                        ) : (
                          <span style={{ color: "#9ca3af" }}>—</span>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {access?.editMemberAccess && (
                          <div className="row-actions">
                            <Button
                              onClick={() => {
                                openMemberDetail(row.userId)
                              }}
                              variant="outlined"
                              size="small"
                            >
                              Detail
                            </Button>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}

                {searchResultInfo && searchResultInfo.pages > 1 && (
                  <TableRow key="pagination-row">
                    <TableCell colSpan={8}>
                      <div className="pagination-section">
                        <Pagination
                          count={searchResultInfo.pages}
                          page={searchResultInfo.currentPageNo}
                          onChange={(event, value) => {
                            setSearchOptions({
                              ...searchOptions,
                              pageNo: value,
                            })
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </StyledMemberTable>
  )
}

export default MemberTable
